import { ISubCoverage } from "./sub-coverage.model";

export interface IBenefitList {
    benefitId: string;
    code: string;
    nameEnglish: string;
    nameArabic: string;
    benefitLimit: string;
    patientShareTypeNameArabic: string;
    patientShareTypeNameEnglish: string;
    patientShare: number;
    maxPatientShare: number;
    maxConsultationFee: number;
    approvalThreshold: number;
    networkTypeId: string;
    networkTypeNameEnglish: string;
    networkTypeNameArabic: string;
    termId: string;
    termNameEnglish: string;
    termNameArabic: string;
    unitId?: string;
    unitNameEnglish?: string;
    unitNameArabic?: string;
    erpBenefitId?: string;
}

export interface IBenefit {
    benefitId: string;
    code: string;
    nameEnglish: string;
    nameArabic: string;
    deductible: number;
    visit: number;
    roomTypeId: string;
    roomTypeNameEnglish: string,
    roomTypeNameArabic: string,
    visionExam: string;
    visionGlasses: string;
    visionContacts: string;
    medicalPrimaryCare: string;
    pharmacyDispense: string;
    descriptionEnglish: string;
    descriptionArabic: string;
    benefitLimit: number;
    patientShare: string,
    patientShareType: string,
    patientShareTypeDesc: string,
    patientShareTypeNameEnglish: string,
    patientShareTypeNameArabic: string,
    qtyLimit: number,
    qtyFrequency: number,
    qtyFrequencyUnitId: string,
    qtyFrequencyUnitNameEnglish: string,
    qtyFrequencyUnitNameArabic: string,
    maxLimit: number,
    maxLimitFrequency: number,
    maxLimitFrequencyUnitId: string,
    maxLimitFrequencyUnitNameEnglish: string,
    maxLimitFrequencyUnitNameArabic: string,
    maxPatientShare: number,
    maxConsultationFee: number,
    approvalThreshold: number,
    coverage: string,
    exclusions: string,
    comments: string,
    isCovered?: boolean,
    subCoverages?: ISubCoverage[];
    networkTypeId: string;
    networkTypeNameEnglish: string;
    networkTypeNameArabic: string;
    termId: string;
    termNameEnglish: string;
    termNameArabic: string;
    unitId?: string;
    unitNameEnglish?: string;
    unitNameArabic?: string;
    erpBenefitId?: string;
}

export const benefitConfig = {
    entityName: 'CONFIGURATION.BENEFIT.TITLE',
    englishName: 'FORM_FIELD.ENGLISH_NAME',
    arabicName: 'FORM_FIELD.ARABIC_NAME',
    descriptionEnglish: 'FORM_FIELD.ENGLISH_DESCRIPTION',
    descriptionArabic: 'FORM_FIELD.ARABIC_DESCRIPTION',
    benefitLimit: 'FORM_FIELD.LIMIT',
    maxPatientShare: 'FORM_FIELD.MAX_PATIENT_SHARE',
    maxConsultationFee: 'FORM_FIELD.MAX_CONSULATION_FEE',
    approvalThreshold: 'FORM_FIELD.APPROVAL_THRESHOLD',
    qtyLimit: 'FORM_FIELD.LIMIT',
    qtyFrequency: 'FORM_FIELD.FREQUENCY_IN_UNIT',
    maxLimit: 'FORM_FIELD.MAXIMUM_LIMIT',
    maxLimitFrequency: 'FORM_FIELD.MAXIMUM_LIMIT_FREQUENCY_IN_UNIT',
    coverage: 'FORM_FIELD.COVERAGE',
    comments: 'FORM_FIELD.COMMENTS',
    exclusions: 'FORM_FIELD.EXCLUSION',
    patientShare: 'FORM_FIELD.PATIENT_SHARE',
    qtyFrequencyUnitId: 'FORM_FIELD.FREQUENCY',
    maxLimitFrequencyUnitId: 'FORM_FIELD.MAXIMUM_LIMIT_FREQUENCY',
    caseTypeId: 'CONFIGURATION.MASTER_DATA.CASE_TYPE.TITLE',
    SAR: 'FORM_FIELD.SAR',
    PERCENTAGE: '%',
    pharmacyDispense: 'FORM_FIELD.PHARMACY_DISPENSE',
    medicalPrimaryCare: 'FORM_FIELD.MEDICAL_PRIMARY_CARE',
    visionContacts: 'FORM_FIELD.VISION_CONTACTS',
    visionGlasses: 'FORM_FIELD.VISION_GLASSES',
    visionExam: 'FORM_FIELD.VISION_EXAM',
    room: 'FORM_FIELD.ROOM',
    visit: 'FORM_FIELD.VISIT',
    deductible: 'FORM_FIELD.DEDUCTIBLE',
    code: 'FORM_FIELD.CODE'
};